export default __webpack_public_path__ + "static/media/mq-new-3.89f2e25b.jpg";